module.exports = __webpack_public_path__ + "media/images/rolltore-a9811803374a5560d46e961a3feaf373.jpg";